import GroupEncryptionWorkerManager from './groupEncryptionWorkerManager';

const groupCryptoManager = new GroupEncryptionWorkerManager();

const sendGroupCryptoDB = groupCryptoManager.getSendWorker();

export default sendGroupCryptoDB;
